import { createReducer, on } from '@ngrx/store';
import { reset } from './action';
import { AppState } from './state/app-state.interface';

export const initialState: AppState = null;

export const appReducer = createReducer(initialState, on(reset, state => null));
